declare global {
  interface Window {
    // For Google Tag Manager
    dataLayer: any[];
    gtag: (...args: any[]) => void;

    // For Tawk.to
    Tawk_API: any;
    Tawk_LoadStart: Date;
  }
}

// Helper to load a script and return a promise
function loadScript(src: string, async = true, defer = true): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = async;
    script.defer = defer;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });
}

// Function to get a cookie
function getCookie(cname: string): string {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return 'false';
}

// Initialize dataLayer and Consent
function initializeGtm() {
  // This part is safe to run early as it's just initializing variables.
  // Or it can be run just before the GTM script is loaded.
  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer.push(args);
  }

  // Set default consent. This MUST run before GTM script itself.
  gtag('consent', 'default', {
    ad_storage:
      getCookie('cookies-bar-consent-marketing') === 'true'
        ? 'granted'
        : 'denied',
    ad_user_data:
      getCookie('cookies-bar-consent-marketing') === 'true'
        ? 'granted'
        : 'denied',
    ad_personalization:
      getCookie('cookies-bar-consent-marketing') === 'true'
        ? 'granted'
        : 'denied',
    analytics_storage:
      getCookie('cookies-bar-consent-analytic') === 'true'
        ? 'granted'
        : 'denied',
    personalization_storage:
      getCookie('cookies-bar-consent-preferential') === 'true'
        ? 'granted'
        : 'denied',
    security_storage: 'granted',
  });
}

// Load the GTM script
function loadGtmScript(gtmId: string) {
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  const gtmSrc = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  return loadScript(gtmSrc);
}

// --- The main export function ---
export function loadThirdPartyScripts(gtmId: string) {
  // Initialize GTM dataLayer and consent IMMEDIATELY
  initializeGtm();

  // Load the scripts after a delay to ensure LCP has passed.
  const load = () => {
    loadGtmScript(gtmId).catch(console.error);
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(load);
  } else {
    // Fallback for older browsers
    setTimeout(load, 2000);
  }
}
